import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { RELEASE_OCOYA_PRODUCT, RELEASE_TRADEMARKS } from '#client/constants/experimentsFlags';
import { useProductCards } from '#client/hooks/useProductCards';

function isCardExcluded(card, excludedCardSet) {
  const hasService = excludedCardSet.has(card.product?.service);
  const hasTitle = excludedCardSet.has(card.title);
  const hasModalName = excludedCardSet.has(card.primaryCta?.modalName);
  return hasService || hasTitle || hasModalName;
}

export function useFilteredProductCards(categories) {
  const exclusionSet = new Set();
  const showOcoyaCard = useExperimentFlag(RELEASE_OCOYA_PRODUCT, false);
  const showTrademarks = useExperimentFlag(RELEASE_TRADEMARKS, false);
  const {
    data: productsResponse,
    loading,
    error,
    refetch
  } = useProductCards(categories);

  if (!showOcoyaCard) {
    exclusionSet.add('Ocoya Social Media');
  }

  if (!showTrademarks) {
    exclusionSet.add('trademarks_search');
  }

  const filteredProductCards = productsResponse?.cards.filter(
    (card) => !isCardExcluded(card, exclusionSet)
  );

  const data = {
    cards: filteredProductCards,
    categories: productsResponse.categories
  };

  return {
    data,
    loading,
    error,
    refetch
  };
}
